import clsx from 'clsx';
import React, { useRef, useState } from 'react';
import { callMultiple, remToPx, useComposedRefs, useElementSize, } from '../../utils';
import { Checkbox } from '../Checkbox';
import { customMedia } from '@mollie/ui-tokens';
import './Toggle.css';
export function Toggle(props) {
    const { children, role = 'switch', label, description, className, containerSize, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, size, variant, onClick, UNSAFE_elementType = label || description || children ? 'label' : 'span', UNSAFE_contentClassName, UNSAFE_indicatorClassName, inputRef: userInputRef, UNSAFE_labelRef, ...rest } = props;
    const [element, setElement] = useState(null);
    const [isSmallContainerSize, setIsSmallContainerSize] = useState(false);
    const inputRef = useRef(null);
    useElementSize(element === null || element === void 0 ? void 0 : element.parentNode, (size) => {
        setIsSmallContainerSize(size.width <= remToPx(customMedia['small'].max));
    });
    return (React.createElement(Checkbox, { ...rest, value: "true", role: role, className: clsx('mollie-ui-toggle', {
            'mollie-ui-toggle--container-small': !containerSize && isSmallContainerSize,
            [`mollie-ui-toggle--container-${containerSize}`]: containerSize,
            [`mollie-ui-toggle--${size}`]: size,
            [`mollie-ui-toggle--${variant}`]: variant,
        }, className), "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, onClick: callMultiple(onClick, (e) => {
            if (inputRef.current && e.target !== inputRef.current) {
                e.preventDefault();
                e.stopPropagation();
                inputRef.current.click();
            }
        }), UNSAFE_elementType: UNSAFE_elementType, UNSAFE_contentClassName: clsx('mollie-ui-toggle-content', UNSAFE_contentClassName), UNSAFE_indicatorClassName: clsx('mollie-ui-toggle-indicator', UNSAFE_indicatorClassName), UNSAFE_indicatorContent: null, UNSAFE_labelRef: useComposedRefs(setElement, UNSAFE_labelRef), inputRef: useComposedRefs(inputRef, userInputRef) },
        label && React.createElement("div", { className: "mollie-ui-toggle-label" }, label),
        description,
        children));
}
//# sourceMappingURL=Toggle.js.map